import React, { useEffect, useState } from 'react'
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';


function BackToTopButton() {
  const [BackToTopButton, setBackToTopButton] = useState(false)

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 100) {
        setBackToTopButton(true)
      } else {
        setBackToTopButton(false)
      }
    })
  })

  const scrollUp = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    })
  }

  return (
    BackToTopButton &&

    <KeyboardDoubleArrowUpIcon

      sx={{
        'z-index': '1000',
        position: "relative",
        'border-radius': '50%',
        color: "black",
        bgcolor: "white",
        position: "fixed",
        bottom: "50px",
        right: "50px",
        weight: "50px",
        fontSize: "50px",
        '&:hover': {
          color: "white",
          bgcolor: "black",
        }
      }}

      onClick={scrollUp}
    >
      BackToTopButton
    </KeyboardDoubleArrowUpIcon>
  )
}

export default BackToTopButton;